import {
    buttonActionFunc
} from "./common/_buttonAction";
import {
    headerFunc
} from "./common/_header";
import {
    footerFunc
} from "./common/_footer";
import {
    commonFunc
} from "./common/_common";
import {
    homeFunc
} from "./pages/_home";

$(window).on('load', function () {
    commonFunc();
    headerFunc();
    footerFunc();
    buttonActionFunc();
    homeFunc();
});

/**
 * ヘッダー分コンテンツを下げる
 */
$(window).on('load resize', function() {
  const headerHeight = $('.l-header').height();
  $('.l-wrapper').css('margin-top', headerHeight);
  $('.l-drawer').css('padding-top', headerHeight);
});

const aboutSwiper = new Swiper(".about-swiper", {
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 7,
  speed: 8000,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
  },
  breakpoints: {
    768: {
      spaceBetween: 30,
    },
  },
});

const recruitSwiper = new Swiper(".recruit-swiper", {
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 7,
  speed: 8000,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
  },
  breakpoints: {
    768: {
      spaceBetween: 30,
    },
  },
});

const serviceSwiperSp = new Swiper(".service-swiper-sp", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 10,
  speed: 3000,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  pagination: {
    el: '.p-home-service-slide .swiper-pagination',
    clickable: true,
    type: 'bullets'
  },
});

const serviceSwiperPc = new Swiper(".service-swiper-pc", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 10,
  speed: 3000,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  pagination: {
    el: '.p-home-service-slide--pc .swiper-pagination',
    clickable: true,
    type: 'bullets'
  },
});

const recruitConceptSwiper = new Swiper(".recruit-concept-swiper", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 10,
  speed: 3000,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  navigation: {
    nextEl: ".p-recruit-concept .swiper-button-next",
    prevEl: ".p-recruit-concept .swiper-button-prev",
  },
});

const breakPoint = 1280;
const breakPoint02 = 768;
let productEcoricaSwiper = null;
let productPlaisirSwiper = null;
let productRinokaSwiper = null;
let recruitActivitySwiper = null;
let swiperBool;
let swiperBoolRe;

window.addEventListener(
  "load",
  () => {
    if (breakPoint < window.innerWidth) {
      swiperBool = false;
    } else {
      createEcoricaSwiper();
      createPlaisirSwiper();
      createRinokaSwiper();
      swiperBool = true;
    }
    if (breakPoint02 < window.innerWidth) {
      swiperBoolRe = false;
    } else {
      createActivitySwiper();
      swiperBoolRe = true;
    }
  },
  false
);

window.addEventListener(
  "resize",
  () => {
    if (breakPoint < window.innerWidth && swiperBool) {
      productEcoricaSwiper.destroy(false, true);
      productPlaisirSwiper.destroy(false, true);
      productRinokaSwiper.destroy(false, true);
      // recruitActivitySwiper.destroy(false, true);
      swiperBool = false;
    } else if (breakPoint >= window.innerWidth && !swiperBool) {
      createEcoricaSwiper();
      createPlaisirSwiper();
      createRinokaSwiper();
      // createActivitySwiper();
      swiperBool = true;
    }
    if (breakPoint02 < window.innerWidth && swiperBoolRe) {
      recruitActivitySwiper.destroy(false, true);
      swiperBoolRe = false;
    } else if (breakPoint02 >= window.innerWidth && !swiperBoolRe) {
      createActivitySwiper();
      swiperBoolRe = true;
    }
  },
  false
);

const createEcoricaSwiper = () => {
  productEcoricaSwiper = new Swiper(".product-ecorica-swiper", {
    slidesPerView: 2,
    spaceBetween: 16,
    loop: true,
    speed: 1500,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".p-product-ecorica .swiper-button-next",
      prevEl: ".p-product-ecorica .swiper-button-prev",
    },
  });
};

const createPlaisirSwiper = () => {
  productPlaisirSwiper = new Swiper(".product-plaisir-swiper", {
    slidesPerView: 2,
    spaceBetween: 16,
    loop: true,
    speed: 1500,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".p-product-plaisir .swiper-button-next",
      prevEl: ".p-product-plaisir .swiper-button-prev",
    },
  });
};

const createRinokaSwiper = () => {
  productRinokaSwiper = new Swiper(".product-rinoka-swiper", {
    slidesPerView: 2,
    spaceBetween: 16,
    loop: true,
    speed: 1500,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".p-product-rinoka .swiper-button-next",
      prevEl: ".p-product-rinoka .swiper-button-prev",
    },
  });
};

const createActivitySwiper = () => {
  recruitActivitySwiper = new Swiper(".recruit-activity-swiper", {
    slidesPerView: 2,
    spaceBetween: 16,
    loop: true,
    speed: 1500,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".p-recruit-activity .swiper-button-next",
      prevEl: ".p-recruit-activity .swiper-button-prev",
    },
  });
};